/**
 * Detecta si el usuario está accediendo a través del subdominio admin.
 */
export const isAdminSubdomain = (): boolean => {
    // Si estamos en local, podemos usar un parámetro URL para pruebas
    // ej: localhost:5173/?mode=admin
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('mode') === 'admin') return true;
    if (window.location.pathname.startsWith('/admin')) return true;

    const hostname = window.location.hostname;

    // Verifica si el hostname comienza con 'admin.'
    return hostname.startsWith('admin.');
};
